<div>
  <ng-template appStrategia></ng-template>
</div>
